import { render, staticRenderFns } from "./AgentFrontTemplate.vue?vue&type=template&id=42bcaaf0&scoped=true"
import script from "./AgentFrontTemplate.vue?vue&type=script&lang=js"
export * from "./AgentFrontTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bcaaf0",
  null
  
)

export default component.exports